import './NotificationBanners.pcss';
import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { orderBy } from 'lodash';
import classNames from 'classnames';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps>;

type Props = OuterProps & InnerProps;

const NotificationBanners = (props: Props) => {
  const { notificationBanners } = props;
  const [bannerClosed, setBannerClosed] = useState(false);

  useEffect(() => {
    setBannerClosed(false);
  }, [notificationBanners]);

  if (!notificationBanners || !notificationBanners.length || bannerClosed) {
    return null;
  }

  const orderedNotificationBanners = orderBy(notificationBanners, ['priority']);

  const containerClassName = classNames('notification-banners');

  return (
    <div className={containerClassName}>
      {orderedNotificationBanners.map(notificationBanner => (
        <div
          key={notificationBanner.message}
          className="notification-banners__banner"
        >
          <span>{notificationBanner.message}</span>
          <div
            className="notification-banners__close-icon"
            onClick={() => setBannerClosed(true)}
          >
            x
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  notificationBanners: state.env.notificationBanners,
});

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

export default enhance(NotificationBanners);
